import { TemplateString } from '@awesome-nodes/object';
import { InjectionProviderException } from "./injection/InjectionProviderException";
export class InjectableDependencyNotFoundException extends InjectionProviderException {
  constructor(scope, provider, token) {
    super(scope, token, provider, TemplateString`Can not determine dependencies of injectable '${'token'}'. The provider of dependency '${'provider'}' has no matching injection token registered within scope ${'scope'}! `);
    InjectableDependencyNotFoundException.setPrototype(this);
  }

}
